/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import {
 Modal, Input, Button, Checkbox, message 
} from "antd"
import SmsCodeVerify from "@/components/rc-sms-verify"
import ImgVerify from "@/components/rc-img-verify"
import {
  $cookie,
  isPhone,
  floatMultiple,
  isCode,
  isNumberInput,
  sessionstorage,
  getSuccessMsg
} from "$utils"
import { intentCommon } from "../service"
import { UseIntentOrderExt } from "../order-ext"
import { UseModalSuccess } from "../success"
import styles from "./styles.scss"
import $dom from "../../../util"

// 降价提醒弹窗
const IntentDiscountNotify = (props) => {
  const { onClose, submitParams, otherParams } = props
  const [visible, setVisible] = useState(props.visible)
  const [priceTo, setPriceTo] = useState()
  const [mobileNumber, setMobileNumber] = useState(
    $cookie.get("rrc_login_phone") || sessionstorage.get("intentPhone") || ""
  )
  const [noteChecked, setNoteChecked] = useState(true)
  // 图形验证码
  const [imgVerify, setImgVerify] = useState(false)
  const [imgVerifyCode, setImgVerifyCode] = useState(false)

  // 短信验证码
  const [smsVerify, setSmsVerify] = useState(false)
  const [smsVerifyCode, setSmsVerifyCode] = useState(true)

  const [errMsg, setErrMsg] = useState()
  const priceToRef = useRef()
  useEffect(() => {
    if (Number(priceTo) > Number(submitParams.owner_price)) {
      setErrMsg("出价已经高于原价啦")
    } else {
      setErrMsg("")
    }
  }, [priceTo])
  const closeModal = () => {
    global.$rbl.push("car-detail_pricenotificationpop_close")
    setVisible(false)
    onClose && onClose()
  }
  // 降价提醒线索提交
  const discountSubmit = async (_isrefresh) => {
    global.$rbl.push("咨询-PC-详情页-2")
    global.$rbl.push("car-detail_pricenotificationpop_submit")
    setErrMsg("")
    if (!Number(priceTo)) {
      setErrMsg("请输入砍价金额")
      priceToRef.current?.focus()
      return
    }
    if (Number(priceTo) > Number(submitParams.owner_price)) {
      setErrMsg("出价已经高于原价啦")
      return
    }
    if (!isPhone(mobileNumber)) {
      setErrMsg("手机号输入有误")
      return
    }
    if (!_isrefresh && imgVerify && imgVerifyCode && !isCode(imgVerifyCode)) {
      setErrMsg("图形验证码输入有误")
      return
    }
    if (smsVerify === true && (!smsVerifyCode || !isCode(smsVerifyCode))) {
      setErrMsg("短信验证码输入有误")
      return
    }
    const params = {
      ...submitParams,
      model_name: "discount_notify",
      price: priceTo,
      mobile_number: mobileNumber
    }
    // 图形验证码参数
    if (imgVerify && imgVerifyCode && isCode(imgVerifyCode)) {
      params.verify_code = imgVerifyCode
    }
    // 短信验证码参数
    if (smsVerify && smsVerifyCode && isCode(smsVerifyCode)) {
      params.verification_code = smsVerifyCode
    }
    try {
      const result = await intentCommon(params)
      $dom.popLayerSubmit()
      if (result.data.display_next_page === true) {
        const nextSubmitParams = {
          ...submitParams,
          phone: mobileNumber,
          sub_product: "discount_notify",
          model_name: "discount_notify"
        }
        new UseIntentOrderExt({
          isSmsVerify: smsVerify,
          modelName: "discount_notify",
          submitParams: nextSubmitParams,
          otherParams,
          profile: result.data.profile
        }).open()
      } else {
        const showSuccess = () => {
          new UseModalSuccess({
            msg: result.data.notice_message || getSuccessMsg("discount_notify")
          }).open()
        }
        // 未登录提交信息补充后，应该弹出登录弹窗，并发送短信验证码
        if (
          !smsVerify &&
          !$cookie.get("rrc_login_phone") &&
          !$cookie.get("rrc_login_token")
        ) {
          sessionstorage.set("loginBackModalInfo", {
            msg: result.data.notice_message || getSuccessMsg("discount_notify")
          })
          window.location.href = `${
            window.location.origin
          }/login?source=${encodeURIComponent(
            window.location.href
          )}&phone=${mobileNumber}`
          // new UseLogin({
          //   isAutoMsg: false,
          //   isAutoLogin: true,
          //   phone: mobileNumber,
          //   onSuccessCallBack: () => {
          //     showSuccess()
          //   }
          // }).open()
        } else {
          showSuccess()
        }
      }
      closeModal()
      global.$rbl.push(`${submitParams.submit_sources}-提交成功`)
    } catch (error) {
      console.log(error)
      if (error.status === 200) {
        const result = error.data
        setImgVerify("")
        setErrMsg("")
        if (result.status === 400) {
          // 图形验证码
          global.$rbl.push({
            event: "m_verification_show",
            content: { param: "verification" }
          })
          setImgVerify(result.image)
        } else if (result.status === 1000) {
          // 短信验证码
          setSmsVerify(true)
        } else if (result.status === 1001) {
          // 短信验证码校验失败
          setErrMsg("短信验证码输入有误")
        } else {
          message.error(result?.err_msg || result?.errMsg || "未知错误")
        }
      }
    }
  }
  return (
    <Modal
      centered
      visible={visible}
      footer={null}
      style={{ minWidth: "520px" }}
      bodyStyle={{ padding: "0px" }}
      onCancel={() => {
        closeModal()
      }}
    >
      <div className={styles.intentModal}>
        <div className="logo">
          <i className="iconfont icon-shouji" />
        </div>
        <h2 className="title">降价提醒</h2>
        <p className="msg">
          <span>卖家报价 </span>
          <span className="price">
            {Number(submitParams?.owner_price).toFixed(2)}万
          </span>{" "}
          建议价{Number(submitParams?.owner_price).toFixed(2)}-
          {floatMultiple(submitParams?.owner_price, 0.8).toFixed(2)}万
        </p>
        <Input
          ref={priceToRef}
          onClick={() => {
            global.$rbl.push("car-detail_pricenotificationpop_inputbox")
          }}
          className="priceTo"
          placeholder="降到多少通知我"
          suffix="万"
          size="large"
          value={priceTo}
          onInput={(e) => {
            if (isNumberInput(e.target.value)) {
              setPriceTo(e.target.value)
            }
          }}
        />
        <Input
          onClick={() => {
            global.$rbl.push("car-detail_pricenotificationpop_mobile")
          }}
          size="large"
          className="phone"
          placeholder="请输入您的手机号"
          maxLength={11}
          suffix={<i className="iconfont icon-shouji" />}
          value={mobileNumber}
          onChange={(e) => {
            setMobileNumber(e.target.value)
          }}
        />
        {/* 防刷图形验证码 */}
        <ImgVerify
          className="image-verify"
          imgVerify={imgVerify}
          onImgVerifyCode={(code) => {
            setImgVerifyCode(code)
          }}
          onRefresh={() => {
            discountSubmit(true)
          }}
        />
        {/* 防刷短信验证码 */}
        <SmsCodeVerify
          autoSend
          phone={mobileNumber}
          smsVerify={smsVerify}
          onErrMsg={(err) => {
            setErrMsg(err)
          }}
          onSmsCode={(code) => {
            setSmsVerifyCode(code)
          }}
        />
        <p className="err-msg">{errMsg}</p>
        <Button
          size="large"
          type="primary"
          block
          className="submit"
          onClick={discountSubmit}
          disabled={!noteChecked}
        >
          提交
        </Button>
        <div className="tip clearfix">
          <Checkbox
            className="check"
            checked={noteChecked}
            onChange={(e) => {
              setNoteChecked(e.target.checked)
            }}
          />
          <p className="txt">
            阅读并同意
            <a
              href="https://sta.renrenche.com/legal/terms.html"
              target="_blank"
              onClick={() => {
                closeModal()
              }}
            >
              《用户服务协议》
            </a>
            、
            <a
              href="https://sta.renrenche.com/legal/privacy.html"
              target="_blank"
              onClick={() => {
                closeModal()
              }}
            >
              《隐私政策》
            </a>
            提交并注册为用户。
          </p>
        </div>
      </div>
    </Modal>
  )
}

IntentDiscountNotify.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func
}

IntentDiscountNotify.defaultProps = {
  visible: false,
  onClose: null
}

function mountAnywhere(Comp, root) {
  const div = document.createElement("div");
  (root || document.body).appendChild(div)
  // 向组件注入 onClose 方法，以便组件能调用关闭
  const Clone = React.cloneElement(Comp, {
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div)
      div.parentNode.removeChild(div)
    }
  })
  ReactDOM.render(Clone, div)

  return div
}

export class UseIntentDiscountNotify {
  constructor(params) {
    this.visible = false
    this.ref = null
    this.submitParams = params.submitParams
    this.otherParams = params.otherParams
  }

  open() {
    this.visible = true
    this.ref = mountAnywhere(
      <IntentDiscountNotify
        visible={this.visible}
        submitParams={this.submitParams}
        otherParams={this.otherParams}
      />
    )
    return this.ref
  }

  close() {
    this.visible = false
  }
}
export default IntentDiscountNotify
